import * as React from 'react';
import styled from '../theme';

const Content = styled.h3`
    width: 85%;
    margin: 0 auto;
    text-align: center;
    font-weight: 200;
    font-size: 1em;
    line-height: 2;
    color: ${(props: any) => props.theme.colors.bodyLight};
`

const SubText = (props: { content: string }) => (
    <Content>
        {props.content}
    </Content>
)

export default SubText;



// WEBPACK FOOTER //
// ./src/components/SubTextComponent.tsx